import styled, { css } from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';

import { ThemeProps } from 'types/styled';

export const RootLayout = styled.form`
  display: flex;
  margin-bottom: ${(p) => p.theme.spacing.medium};
`;

export const LayoutWrapper = styled.div<ThemeProps<'div'>>`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;

  ${({ limit }) => `
    @supports (grid-template-columns: repeat(${limit}, 1fr)) {
      display: grid;
      grid-template-columns: repeat(${limit}, 1fr);
      grid-gap: 0.5rem;
    }
  `}
`;

export const Radio = styled('input')`
  position: absolute;
  clip: rect(0, 0, 0, 0);

  &:checked + label {
    border-bottom: 5px solid ${(p) => p.theme.AccentGreen};
  }

  &:hover:not(:checked) + label,
  &:focus:not(:checked) + label {
    background: ${({ theme }) => theme.VeryLightGrey};
  }

  &:active:not(:checked) + label {
    background: ${({ theme }) => theme.LightGrey};
  }

  &:disabled:not(:checked) + label {
    background: ${({ theme }) => theme.LightGrey};
    color: ${({ theme }) => theme.CasperGrey};
    cursor: not-allowed;

    svg {
      opacity: 0.5;
    }
  }
`;

const sharedStyles = css`
  min-height: 4rem;
  padding: ${(p) => `${p.theme.spacing.xsmall} ${p.theme.spacing.medium}`};
  background: ${(p) => p.theme.Sand};
  border-bottom: 5px solid transparent;
  border-top: 5px solid transparent;
`;

export const Label = styled.label`
  ${sharedStyles}
  max-width: 20%;
  flex: 0 0 20%;
  display: flex;
  align-items: center;

  @supports (grid-template-columns: repeat(5, 1fr)) {
    max-width: initial;
    flex: none;
  }
  .value {
    display: block;
    font-weight: 600;
  }
  .positions {
    display: block;
    font-size: ${modularScale(-1)};
    color: ${(p) => p.theme.CasperGrey};
    line-height: 1.2;
  }
`;

export const ShowMore = styled.button<ThemeProps<'button'>>`
  ${sharedStyles}
  font-weight: 600;
  margin-left: 0.5rem;
  align-self: flex-start;

  ${({ theme, isExpanded, showActive }) => css`
    background: ${isExpanded ? theme.VeryLightGrey : theme.Sand};
    border-bottom: ${showActive ? `5px solid ${theme.AccentGreen}` : 'initial'};

    svg {
      margin-left: ${theme.spacing.small};
      transition: transform 200ms;
      transition-timing-function: ${theme.timingFunction};
      transform: ${isExpanded ? 'rotate(270deg)' : 'rotate(90deg)'};
    }

    &:hover {
      background: ${theme.VeryLightGrey};
    }

    &:active {
      background: ${theme.LightGrey};
    }
  `}
`;
